import { call, put } from "redux-saga/effects";
import ApiFetcher from "../utils/ApiFetcher";
import {
  SAGA_LOGIN_SUCCESS,
  SAGA_GET_USER_PROFILE_SUCCESS,
  SAGA_LOGIN_ERROR,
  SAGA_LOGIN_INVALID
} from "../constants";
import _ from "lodash";

const apiFetcher = new ApiFetcher();
export function* signin(action) {
  let data = {
    auth: action.data
  };
  try {
    const res = yield call(
      apiFetcher.post,
      "/api/auth/password-authenticate",
      data
    );
    if (res.status === 201) {
      yield put({
        type: SAGA_LOGIN_SUCCESS,
        data: res.data
      });
    } else {
      yield put({
        type: SAGA_LOGIN_INVALID
      });
    }
  } catch (error) {
    console.error(error);
    yield put({ type: SAGA_LOGIN_ERROR });
  }
}

export function* getUserProfile(action) {
  let config = ApiFetcher.getConfig();
  try {
    const res = yield call(
      ApiFetcher.makeRequest,
      "get",
      "accounts/profile",
      {},
      config
    );
    yield put({
      type: SAGA_GET_USER_PROFILE_SUCCESS,
      data: res.data.user
    });
  } catch (error) {
    console.error(error);
    //yield put({ type: SAGA_FETCH_TRANSACTION_ERROR });
  }
}



// WEBPACK FOOTER //
// ./src/sagas/auth.js